import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { Badge } from 'reactstrap';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import Items from './Items';
import columnTypes from '../../components/cms/grid/columnTypes';
import ModelService from '../../services/video.service';
import CompanyService from '../../services/company.service';
import gc from '../../components/cms/gridComponents';
import PreviewImage from '../../components/previewImage';

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>),
  },
  {
    name: 'animation_name',
    title: t('Template'),
    value: ({ item }) => (
      item.animation_name + " " +  item.animation_ratio
      + ' ('+item.width+'x'+item.height+') '
      + item.duration + 'sec'
    ),
  },
  // {
  //   name: 'animation_ratio',
  //   title: t('Ratio'),
  //   value: ({ item }) => item.animation_ratio,
  // },
  {
    name: 'company_title',
    title: t('Company'),
    value: ({ item }) => (<Link to={CompanyService.getUpdateUrl(item.company_id)}>{item.company_title}</Link>),
  },
  {
    name: 'preview_file_id',
    title: '',
    value: ({ item }) => (
      <div className="center">
        {item.preview_file_view_code && (
          <Link to={ModelService.getUpdateUrl(item.id)}>
            <PreviewImage height="70" src={ModelService.getImage2(item.preview_file_view_code)} alt={item.title} />
          </Link>
        )}
      </div>
    ),
    filter: false,
    sort: false,
  },
  {
    name: 'video_file_id',
    title: '',
    value: ({ item }) => (
      <div className="center">
        {item.video_file_id && <a
          href={ModelService.getImage2(item.video_file_view_code)}
          target="_blank"
          download
        >Download</a>}
      </div>
    ),
    filter: false,
    sort: false,
  },
  {
    name: 'title',
    title: t('Title'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.title}</Link>),
  },
  {
    name: 'type',
    title: t('Type'),
    value: ({ item: { type } }) => (
      <Badge color={ModelService.getColorByType(type)}>
        {ModelService.getTypeTitle(type, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getTypeOptions(t)),
  },
  {
    name: 'status',
    title: t('Status'),
    value: ({ item: { status } }) => (
      <Badge color={ModelService.getColorByStatus(status)}>
        {ModelService.getStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  {
    type: columnTypes.BUTTONS,
    customButtons: ({ item }) => (<button className="btn btn-warning btn-sm mr-1 icon" onClick={() => ModelService.render(item.id)}><span className="fa fa-cube"></span></button>),
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
    service: ModelService,
  }),
);

export default hoistStatics(enhance)(Items);



// WEBPACK FOOTER //
// ./src/views/videos/index.js